import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { PostPatientArchiveBody } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Mutation hook for archiving a patient. Invalidates the patient and patients list queries on success. */
export function useArchivePatient(patientId: string) {
  const api = useOsApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (body: PostPatientArchiveBody) => {
      const response = await api.post('/patients/:patientId/archive', {
        params: { patientId },
        body,
      })
      if (!response.success) throw new Error(response.error.message)
      return response.data.patient
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['patient', patientId] })
      queryClient.invalidateQueries({ queryKey: ['patients'] })
    },
  })
}
